export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/wxGrTktgNqBJN2cqUqGege/PAGINA_1_GEOLOGIA.jpg',
    alt: 'Copertina del Volume 1, Fondamenti di Geologia e Sistemi della Terra, con la sezione interna del pianeta, un vulcano e una parete di strati rocciosi',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/t1nXgJTmzASm8tVuqzsrvT/PAGINA_2_GEOLOGIA.jpg',
    alt: 'Pagina di esempio Il Cuore Metallico del Pianeta: nucleo esterno e nucleo interno, con punto chiave',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pWtVCDHLavVSmUqzSSNVym/PAGINA_3_GEOLOGIA.jpg',
    alt: 'Pagina di esempio Tutte le Rocce Appartengono a Tre Grandi Famiglie: rocce magmatiche, sedimentarie e metamorfiche, con attività in classe',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/68Zket1heng2TbCzg6KmGp/PAGINA_4_GEOLOGIA.jpg',
    alt: 'Pagina di esempio Tre Modi di Incontrarsi: i margini divergenti, convergenti e trasformi delle placche',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/fxw5nMaLmzjPF5UY4CbFwR/PAGINA_5_GEOLOGIA.jpg',
    alt: 'Pagina di esempio I Fossili Sono Pagine del Passato: introduzione ai fossili e alla loro utilità',
  },
];
